export const TITLE = "Τίτλος";
export const PRIMARY_BUTTON_TEXT = "Επιβεβαίωση";
export const SECONDARY_BUTTON_TEXT = "Ακύρωση";
export const SAMPLE_TEXT = "Κείμενο δείγμα";
